import { Injectable } from '@angular/core';
import { of } from 'rxjs';

import { HttpClient } from '@angular/common/http';

import { map } from 'rxjs/operators';
import { environment } from './../../environments/environment';
import { Decorable } from '../types/decorable';


@Injectable({
	providedIn: 'root'
})
export class GeocodeService {

	constructor(private http: HttpClient) { }
	public lastResults: any;

	search(term: string, urlParams: Decorable) {
		if (term === '') {
			return of([]);
		}

		const URL = 'https://api.mapbox.com/geocoding/v5/mapbox.places/' + term + '.json';
		urlParams.access_token = environment.mapbox.accessToken;

		const obs = this.http
			.get(URL, { params: urlParams });

		obs.toPromise().then((response) => {
			this.lastResults = response;
		});
		return obs.pipe(
			map(response => (response as any).features)
		);
	}
}
